import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import axios from 'axios';
import { parse, format } from 'date-fns';

const COLORS = {
  putaway: '#00C49F', // Masuk
  picking: '#FF8042', // Keluar
};

type Props = {
  type?: 'qty' | 'transaction';
  selectedMonth?: string;
};

const ProductMovementChart: React.FC<Props> = ({ type = 'qty', selectedMonth }) => {
  const [data, setData] = useState([]);
  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/analytics/movement-line`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        });

        const parsedData = res.data.map((item: any) => {
          const date = parse(item.month, 'yyyy-MM', new Date());
          const monthLabel = format(date, 'MMM yyyy'); // Jul 2025

          return {
            month: monthLabel,
            in: parseInt(item.in, 10),
            out: parseInt(item.out, 10),
          };
        });

        setData(parsedData);
      } catch (error) {
        console.error('Error fetching bar chart data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" className="text-sm"/>
        <YAxis allowDecimals={true} className="text-sm"/>
        <Tooltip />
        <Legend />
        <Bar dataKey="in" fill={COLORS.putaway} name="Stock In" />
		<Bar dataKey="out" fill={COLORS.picking} name="Stock Out" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ProductMovementChart;
